/** 领券 */
/**
 * 怎么领
 * 传领取的类型
 *
 * 无门槛领券： /app/promotion/prom_exec_act.cgi
 * 印花兑换优惠券：/app/promotion/prom_exchange_prize.cgi
 * 印花兑换优惠券（互斥活动）：/app/promotion/prom_mulaction_exchange_prize.cgi
 * 多个派发活动（券包派发）：/app/promotion/rookie_award/hkw_rookie_award_get.cgi
 * 连锁券：/app/promotion/prom_combincoup_exec_act.cgi
 */
import { exchangePrize, execUseract, mulactionExchangePrize } from '@tencent/wphk-act-base-cgi';
/** 领券类型 */
export var GetCouponType;
(function (GetCouponType) {
    /** 无门槛领券 */
    GetCouponType["ExecAct"] = "ExecAct";
    /** 印花兑换优惠券 */
    GetCouponType["ExchangePrize"] = "ExchangePrize";
    /** 印花兑换优惠券（互斥活动） */
    GetCouponType["MulactionExchangePrize"] = "MulactionExchangePrize";
    /** 多个派发活动（券包派发） */
    GetCouponType["HkwRookieAwardGet"] = "HkwRookieAwardGet";
    /** 连锁券 */
    GetCouponType["CombincoupExecAct"] = "CombincoupExecAct";
})(GetCouponType || (GetCouponType = {}));
/** 无门槛领券 */
export async function toExecAct(actListid, prizeNo) {
    return await execUseract({ actListid, prizeNo });
}
/** 印花兑换优惠券 */
export async function toExchangePrize(qualId, actListid, prizeNo) {
    return await exchangePrize({ qualId, actListid, prizeNo });
}
/** 印花兑换优惠券（互斥活动） */
export async function toMulactionExchangePrize(qualId, actId) {
    return await mulactionExchangePrize({ qualId, actId });
}
/** 多个派发活动（券包派发） */
export async function toHkwRookieAwardGet(params) { }
/** 连锁券 */
export async function toCombincoupExecAct(params) { }
/** 领券 */
export const handleGetCoupon = {
    /** 无门槛领券 */
    [GetCouponType.ExecAct]: toExecAct,
    /** 印花兑换优惠券 */
    [GetCouponType.ExchangePrize]: toExchangePrize,
    /** 印花兑换优惠券（互斥活动） */
    [GetCouponType.MulactionExchangePrize]: toMulactionExchangePrize,
    /** 多个派发活动（券包派发） */
    [GetCouponType.HkwRookieAwardGet]: toHkwRookieAwardGet,
    /** 连锁券 */
    [GetCouponType.CombincoupExecAct]: toCombincoupExecAct,
};
